'use client';

import { formatDistanceToNow } from 'date-fns-jalali';
import { useAuth } from 'react-oidc-context';

import { Box, cn, Flex, Skeleton } from '@zoomit/primitives';
import { useUserSummary } from '@zoomit/web-kit';
import { cssVar, Hr, theme, Typography } from '@zoomit/zoomit-ds';

import { useWebKitCustomization } from '../../hooks/useWebKitCustomization';
import SomethingWentWrong from '../empty-state/SomethingWentWrong';

const getRegisterPeriodStr = (date: string) => {
  return formatDistanceToNow(date);
};

type UserDetailType = {
  title: string;
  description: number | string;
};

const UserDetail = (props: UserDetailType) => {
  const { description, title } = props;
  return (
    <Flex flexDirection="column">
      <Typography className="fa" variant="callout-bold" fontSize={1.4} lineHeight={1.8}>
        {description}
      </Typography>
      <Typography variant="callout" textColor={cssVar(theme.grey1)} fontSize={1.2} lineHeight={1.8}>
        {title}
      </Typography>
    </Flex>
  );
};

const UserDetails = () => {
  const tenantPersianTitle = useWebKitCustomization((config) => config.tenantPersianTitle);

  const { isAuthenticated, user } = useAuth();
  const {
    data: summary,
    isLoading: isSummaryLoading,
    isSuccess: isSummarySuccess,
  } = useUserSummary({
    userId: user?.profile.sub as string,
    enabled: isAuthenticated,
  });

  const wrapperClasses = cn('border-borderPrimary grid grid-cols-[auto_auto] gap-4 rounded-md border p-4');

  if (isSummaryLoading || !summary) {
    return (
      <Box className={wrapperClasses}>
        {Array.from({ length: 4 }).map((_, index) => (
          <Flex flexDirection="column" gap={1.5} key={`details-skeleton-${index}`}>
            <Flex alignItems="center" gap={1}>
              <Skeleton width={2.2} height={2.2} />
              <Skeleton height={1.2} width={7.8} />
            </Flex>
            <Skeleton height={1.2} width={11} />
          </Flex>
        ))}
      </Box>
    );
  }

  if (!isSummarySuccess) {
    return (
      <div>
        <SomethingWentWrong />
      </div>
    );
  }

  return (
    <Box className={wrapperClasses}>
      <UserDetail
        title={`عضو ${tenantPersianTitle} هستی`}
        description={getRegisterPeriodStr(summary.registerDate)}
      />
      <UserDetail title="مطلب مطالعه کردی" description={summary.studiedArticlesCount} />
      <Hr style={{ gridColumn: 'span 2' }} />
      <UserDetail title="کامنت‌ گذاشتی" description={summary.commentsCount} />
      <UserDetail title="لایک گرفتی" description={summary.commentsLikeCount} />
    </Box>
  );
};

export default UserDetails;
